import React from 'react';
import Button from '../../Components/Button';
import PlayButton from '../../Components/Button/PlayButton';

const Banner = ({
  toggleDownloadForm,
  toggleRegistrationForm,
  toogleVideoPlayer,
  title,
  description,
  toogleEmiModal
}) => {
  return (
    <section className="banner-container">
      <div className="banner-content">
        <p className="banner-heading-text">{title}</p>
        <span className="banner-description-text">{description}</span>

        <div className="banner-actions-container">
          <Button onClick={toggleDownloadForm} text="DOWNLOAD SYLLABUS" />
          <Button
            onClick={toggleRegistrationForm}
            primary
            text="ENROLL TODAY"
          />
        </div>

        <PlayButton
          onClick={toogleVideoPlayer}
          className="banner-play-element"
        />

        <div className="banner-bottom-element">
          <span
            style={{ cursor: 'pointer' }}
            onClick={toogleEmiModal}
            className="banner-bottom-text">
            {' '}
            EMI AVAILABLE
          </span>
          <span className="banner-bottom-text">LIMITED SLOTS AVAILABE</span>
        </div>
      </div>
    </section>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Banner.js